<template>
    <li :class="{'nav-item': true, 'nav-item menu-is-opening menu-open': isOpen}">
        <a href="#" class="nav-link" @click.prevent="toggleElement">
            <i :class="['nav-icon', item.icon ]"></i>
            <p>
                {{ $t(item.text) }}
                <i class="fas fa-angle-left right"></i>

                <span v-if="showChildrenNumber" class="badge badge-info right">{{ childrenNumber }}</span>
            </p>
        </a>
        <Menu
            :level="level"
            :items="childrens"
            :groupProperty="groupProperty"
        />
    </li>
</template>

<script>

export default {
    mixins: [],
    components: {
        Menu: () => import(/* webpackChunkName: "gestaomenu-menu" */ './Menu'),
    },
    props: {
        level: {
            type: Number,
            default: 0,
        },
        group: {
            type: Object,
            require: true,
        },
        groupProperty: {
            type: String,
            default: 'is_group',
        },
    },
    data() {
        return {
            item: this.group,
        }
    },
    computed: {
        code() {
            return this.item?.code;
        },
        childrens() {
            return (this.item?.items ?? []).sort((a, b) => a.order - b.order);
        },
        childrenNumber() {
            return this.childrens.length;
        },
        showChildrenNumber() {
            return this.item?.showCount ?? false;
        },
        isOpen() {
            return this.item?.open;
        }
    },
    methods: {
        toggleElement() {
            this.item.open = !this.item.open;
        }
    }
}

</script>